import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import moment from "moment";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { fields, fieldsReady } from "../constants";
import { useGroundHandlersNextPage } from "./GroundHolders.hook";

export const GroundHandlersNextPage = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [fieldData, setFieldData] = useState<any>();

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);
  const { data: profileData, error, isLoading, isError, refetch: useRefetchBrand } = useGroundHandlersNextPage();
  useEffect(() => {
    if (!query.get("id")) {
      useRefetchBrand();
    }
  }, []);
  const {
    data: profileDataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
  }, [query.get("id")]);

 const NextPageFormConfig: FormConfig = {
  initialValues: {
    title: profileDataById?.payload ? decodeHTML(profileDataById?.payload?.title) : profileData?.[0]?.title,
    field_content_english_data_nextPage_name: (() => {
      try {
        if (profileDataById?.payload?.field_content_english) {
          const parsed = JSON.parse(profileDataById.payload.field_content_english);
          return decodeHTML(parsed?.data?.nextPage?.name);
        }
        return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.name) || "";
      } catch (error) {
        console.error("Error parsing English nextPage name:", error);
        return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.name) || "";
      }
    })(),

    field_content_english_data_nextPage_link: (() => {
      try {
        if (profileDataById?.payload?.field_content_english) {
          const parsed = JSON.parse(profileDataById.payload.field_content_english);
          return decodeHTML(parsed?.data?.nextPage?.link);
        }
        return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.link) || "";
      } catch (error) {
        console.error("Error parsing English nextPage link:", error);
        return decodeHTML(profileData?.[0]?.field_content_english?.data?.nextPage?.link) || "";
      }
    })(),

    field_content_malay_data_nextPage_name: (() => {
      try {
        if (profileDataById?.payload?.field_content_malay) {
          const parsed = JSON.parse(profileDataById.payload.field_content_malay);
          return decodeHTML(parsed?.data?.nextPage?.name);
        }
        return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.name) || "";
      } catch (error) {
        console.error("Error parsing Malay nextPage name:", error);
        return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.name) || "";
      }
    })(),

    field_content_malay_data_nextPage_link: (() => {
      try {
        if (profileDataById?.payload?.field_content_malay) {
          const parsed = JSON.parse(profileDataById.payload.field_content_malay);
          return decodeHTML(parsed?.data?.nextPage?.link);
        }
        return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.link) || "";
      } catch (error) {
        console.error("Error parsing Malay nextPage link:", error);
        return decodeHTML(profileData?.[0]?.field_content_malay?.data?.nextPage?.link) || "";
      }
    })(),

    field_content_mandarin_data_nextPage_name: (() => {
      try {
        if (profileDataById?.payload?.field_content_mandarin) {
          const parsed = JSON.parse(profileDataById.payload.field_content_mandarin);
          return decodeHTML(parsed?.data?.nextPage?.name);
        }
        return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.name) || "";
      } catch (error) {
        console.error("Error parsing Mandarin nextPage name:", error);
        return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.name) || "";
      }
    })(),

    field_content_mandarin_data_nextPage_link: (() => {
      try {
        if (profileDataById?.payload?.field_content_mandarin) {
          const parsed = JSON.parse(profileDataById.payload.field_content_mandarin);
          return decodeHTML(parsed?.data?.nextPage?.link);
        }
        return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.link) || "";
      } catch (error) {
        console.error("Error parsing Mandarin nextPage link:", error);
        return decodeHTML(profileData?.[0]?.field_content_mandarin?.data?.nextPage?.link) || "";
      }
    })(),
  },
  fields: fieldData?.groundHandlersNextPage,
};

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["appStoreImage", "playStoreImage"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let dateKeys: any = ["date"];
    for (const key of dateKeys) {
      if (data[key]) {
        data[key] = moment(data[key]).format("DD MMM YYYY");
      }
    }

   
    const payload = {
      action: action,
      method: method,
      module: "Stake Holders",
      subModule: `${query?.get("activeTab")}_${query.get("subActiveTab")}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Stake Holders_Ground Handlers",
     payload: {
  id: data?.id || profileData?.[0]?.id || profileDataById?.payload?.id,
  title: data?.title || profileDataById?.payload?.title || profileData?.[0]?.title || "",
  field_content_english: JSON.stringify({
    data: {
      nextPage: {
        name: data?.field_content_english_data_nextPage_name,
        link: data?.field_content_english_data_nextPage_link,
      },
    },
  }),

  field_content_malay: JSON.stringify({
    data: {
      nextPage: {
        name: data?.field_content_malay_data_nextPage_name,
        link: data?.field_content_malay_data_nextPage_link,
      },
    },
  }),

  field_content_mandarin: JSON.stringify({
    data: {
      nextPage: {
        name: data?.field_content_mandarin_data_nextPage_name,
        link: data?.field_content_mandarin_data_nextPage_link,
      },
    },
  }),

  published: true,
},

      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
      isLoading={isLoadingData}
      config={NextPageFormConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${corporateHost}/api/page-content/${profileData?.[0]?.id || profileDataById?.payload?.id || ""}`,
          "UPDATE",
          "PATCH",
          buttonValue == "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
      defaultReviewNotes="Kindly review this Stake Holders"  
    />
  );
};
